export class ProfileInfo {
    activeProfiles: string[];
    ribbonEnv: string;
    inProduction: boolean;
    swaggerEnabled: boolean;

    constructor({inProduction}) {
        this.inProduction = inProduction;
    }
}
